import { ListingPageUrlState } from '../../../redux/products/types';

function shouldRenderSeoText(urlState: ListingPageUrlState) {
    return urlState.page <= 1;
}

export default shouldRenderSeoText;
export { default as SeoTextBottom } from './SeoTextBottom';
export { default as SeoTextTop } from './SeoTextTop';
